﻿import GoogleAnalyticsEvent from 'dataTransferObjects/googleAnalyticsEvent';
import { ProductType, ResultType } from 'features/searchResultsFacets';

const resultTabConfigurationMapper = new Map();
/**
 * New const to handle the click on the tabs for Custom Build and Manufactured home results
 */
const searchEvents = 'Search Events';
const customboyltab = 'Custom & Build On Your Lot Tab';
const searchRefinement = 'Search Refinement';

resultTabConfigurationMapper.set(
  `${ProductType.Custom.toString()}-${ResultType.Homes.toString()}`,
  new GoogleAnalyticsEvent(searchEvents, customboyltab, 'Custom Homes')
);
resultTabConfigurationMapper.set(
  `${ProductType.BuildOnYourLot.toString()}-${ResultType.Locations.toString()}`,
  new GoogleAnalyticsEvent(searchEvents, customboyltab, 'Build On Your Lot')
);
resultTabConfigurationMapper.set(
  `${ProductType.Homes.toString()}-${ResultType.Homes.toString()}`,
  new GoogleAnalyticsEvent(searchEvents, searchRefinement, 'View Homes Tab Clicked')
);
resultTabConfigurationMapper.set(
  `${ProductType.Communities.toString()}-${ResultType.Communities.toString()}`,
  new GoogleAnalyticsEvent(searchEvents, searchRefinement, 'View Communities Tab Clicked')
);
resultTabConfigurationMapper.set(
  `${ProductType.AllProducts.toString()}-${ResultType.Builders.toString()}`,
  new GoogleAnalyticsEvent(searchEvents, searchRefinement, 'View Builders Tab Clicked')
);
resultTabConfigurationMapper.set(
  `${ProductType.Manufactured.toString()}-${ResultType.Homes.toString()}`,
  new GoogleAnalyticsEvent(searchEvents, customboyltab, 'Manufactured Homes')
);
resultTabConfigurationMapper.set(
  `${ProductType.Manufactured.toString()}-${ResultType.Locations.toString()}`,
  new GoogleAnalyticsEvent(searchEvents, customboyltab, 'Manufactured Builders')
);

/**
 * getEventTabConfiguration: Gets event configuration for the tabs to be used according to
 * the product type and result type.
 * @param {string} productTypeName The name of the product type.
 * @returns The Google Analytics event.
 */
function getEventTabConfiguration(productTypeName, resultTypeName) {
  const resultsTabConfiguration = resultTabConfigurationMapper.get(`${productTypeName}-${resultTypeName}`);

  return resultsTabConfiguration ?? null;
}

export default getEventTabConfiguration;
